import React from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

import { objectKeys } from "@nens/shared-utils";

import { getLayers } from "../state/layerOneDMenu";
import { getObjects, getObjectsPerType } from "../state/simulation";
import { OneDElementLayerData } from "../utils/layerUtils";

import LayerMenuOneDElementLayer from "./LayerMenuOneDElementLayer";
import LayerMenuOneDElementLayerPipes from "./LayerMenuOneDElementLayerPipes";
import LayerSubMenu from "./LayerSubMenu";

const LayerMenuOneDElementsSubmenu: React.FC = () => {
  const objects = useSelector(getObjects);
  const objectsPerType = useSelector(getObjectsPerType);

  const oneDLayersDict = useSelector(getLayers);
  const oneDLayersArray = objectKeys(oneDLayersDict).map((type) => {
    const layerConfig = oneDLayersDict[type];

    return {
      layerConfig,
      type,
    };
  });
  const elementLayerConfigs: OneDElementLayerData[] = oneDLayersArray
    .filter((oneDLayer) => {
      return objectsPerType[oneDLayer.type] !== undefined;
    })
    .map((oneDLayer) => {
      const objectsIdsForThisType = objectsPerType[oneDLayer.type];
      const objectsForThisType = objectsIdsForThisType.map((objectId) => objects[objectId]);
      return {
        type: oneDLayer.type,
        style: oneDLayer.layerConfig,
        objectsIdsForThisType: objectsIdsForThisType,
        objectsForThisType: objectsForThisType,
      };
    })
    .filter((obj) => obj.objectsIdsForThisType.length !== 0);

  return (
    <LayerSubMenu>
      <LayerSubMenu.Header>
        <FormattedMessage id="layerMenu.onedElementsHeader" defaultMessage="1D Elements" />
      </LayerSubMenu.Header>

      <LayerSubMenu.ItemList>
        {elementLayerConfigs.map((obj) => {
          // Show pipes differently, because different pipes should also
          // be shown as different (indented) pipes in the legend. (And as
          // different pipes on the map.)
          if (obj.type === "pipes") {
            return <LayerMenuOneDElementLayerPipes layerData={obj} key={obj.type} />;
          } else {
            return <LayerMenuOneDElementLayer layerData={obj} key={obj.type} />;
          }
        })}
      </LayerSubMenu.ItemList>
    </LayerSubMenu>
  );
};

export default LayerMenuOneDElementsSubmenu;
